import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-light btn-sm me-2 mb-1",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectElement && _ctx.selectElement(...args)))
  }, _toDisplayString(_ctx.id), 1))
}